import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Search, X } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { api, inr } from "@/lib/api";

export default function SearchOverlay() {
  const { searchOpen, setSearchOpen } = useStore();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!searchOpen) { setQ(""); setResults([]); }
  }, [searchOpen]);

  useEffect(() => {
    const t = setTimeout(async () => {
      const { data } = await api.get(`/products`, { params: q ? { search: q } : {} });
      setResults(data.products.slice(0, 6));
    }, 200);
    return () => clearTimeout(t);
  }, [q, searchOpen]);

  return (
    <AnimatePresence>
      {searchOpen && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80]" data-testid="search-overlay">
          <div className="absolute inset-0 bg-black/85 backdrop-blur-xl" onClick={() => setSearchOpen(false)} />
          <motion.div initial={{ y: -30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -30, opacity: 0 }}
            className="relative mx-auto mt-24 w-full max-w-2xl px-5">
            <div className="flex items-center gap-3 border-b-2 border-gold/50 pb-4">
              <Search className="text-gold" />
              <input autoFocus value={q} onChange={(e) => setQ(e.target.value)}
                data-testid="search-input"
                placeholder="Search flavours, nachos, chips…"
                className="w-full bg-transparent font-oswald text-2xl text-cream outline-none placeholder:text-white/30" />
              <button onClick={() => setSearchOpen(false)} aria-label="Close search"><X className="text-white/60" /></button>
            </div>
            <div className="mt-6 space-y-2">
              {results.map((p) => (
                <Link key={p.id} to={`/product/${p.slug}`} onClick={() => setSearchOpen(false)}
                  data-testid={`search-result-${p.slug}`}
                  className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-3 transition-colors hover:border-gold/40">
                  <img src={p.image} alt={p.name} className="h-14 w-12 rounded-lg object-cover" />
                  <div className="flex-1">
                    <div className="font-oswald text-cream">{p.name}</div>
                    <div className="text-xs" style={{ color: p.accent }}>{p.flavour}</div>
                  </div>
                  <span className="font-oswald text-gold">{inr(p.price)}</span>
                </Link>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
